import { pick, prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { languageService } from '@theme/js/services/language.service';
import { useGetTemporaryAuthenticationToken } from '@core/js/hooks/auth';
import { useAppSelector, useDeviceSelector, useUserSelector } from '@core/js/store/hooks';
import { useRemoveQueryParams } from '@theme/js/hooks/navigate';

import * as actions from '@core/js/components/system/CommunicationWidgets/store/actions';
import { useIsWidgetsEnabled } from '@core/js/components/system/CommunicationWidgets/hooks/useInitWidgets/hooks/useIsWidgetsEnabled';

export const useLogin = (chatSearchParam) => { /* Lugano changes */
    const { isLoggedIn, lang, userName } = useUserSelector(pick(['lang', 'isLoggedIn', 'userName']));
    const { casinoName, clientType, clientVersion } = useAppSelector(
        pick(['casinoName', 'clientType', 'clientVersion']));
    const getTemporaryAuthenticationToken = useGetTemporaryAuthenticationToken();
    const { enableInbox, enableChat } = useIsWidgetsEnabled(); /* Lugano changes */
    const removeQueryParams = useRemoveQueryParams(); /* Lugano changes */
    const dispatch = useDispatch();
    const clientPlatform = useDeviceSelector(prop('clientPlatform'));

    return useCallback(() => {
        if (!isLoggedIn || !window.Communication) {
            return;
        }

        (async () => {
            const temporaryToken = await getTemporaryAuthenticationToken();

            await window.Communication.API.common.loginByToken({
                userName,
                casinoName,
                clientType,
                clientVersion,
                realMode: 1,
                sessionToken: temporaryToken,
                languageCode: languageService.convertToIMS(lang),
                clientPlatform,
                deliveryPlatform: 'Hub2'
            });

            enableInbox && await window.Communication.API.inbox.subscribe();

            /* Lugano changes */
            if (chatSearchParam === 'true') {
                setTimeout(() => {
                    enableChat && window.Communication.API.chat.maximize();
                    removeQueryParams(['openchat']); /* Lugano changes */
                }, 3000);
            }
            /* Lugano changes */

            dispatch(actions.setIsWidgetsAuthenticated(true));
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoggedIn, lang, userName,
        casinoName, clientType, clientVersion, enableInbox, enableChat,
        getTemporaryAuthenticationToken, clientPlatform, dispatch, chatSearchParam
    ]);
};
